var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-yellow-400"},[(_vm.checked)?_c('i',{staticClass:"fas fa-star",attrs:{"title":"Favorite"}}):_c('i',{staticClass:"far fa-star",attrs:{"title":"Not favorite"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }